import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

@Injectable()
export class IsNotAdminGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate() {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));

    if (currentUser["roles"].includes("admin")) {
      window.alert("You don't have access to this page");
      this.router.navigate([`/account/${currentUser.id}/accountGoals`]);
      // this.router.navigate(["dashboard"]);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/guards/isNot-admin.guard.ts